import React from 'react';

import { Icon, Result, Spin } from 'antd';

import useTransaction from '../../hooks/useTransaction';

import style from './style.module.css';

const ProcessTransaction = () => {
  const { loading, error } = useTransaction();
  
  if (loading) {
    return (
      <Spin
        indicator={<Icon type="loading" style={{ fontSize: 24 }} spin/>}
        tip="Processing the transaction details..."
        className={style.loader}
      />
    )
  }
  
  if (error) {
    return (
      <Result
        status="404"
        title="Something went wrong"
        subTitle={'An error occurred while attempting to evaluate the transaction details.'}
        className={style.errorBox}
      />
    )
  }
  
  return null;
};

export default ProcessTransaction;
